import React from 'react';
import AlertBox from '../ui-components/AlertBox';
import useErrorPush from '../../utils/useErrorPush';

class VoucherRedemption extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      voucher_code: '',
      show_voucher_input: true,
      voucher_code_error_message: '',
      voucher_applied: this.props.voucherApplied,
      voucher_savings: this.props.voucherSavings,
      loading_voucher: false,
      voucher_errors: [],
    };

    this.handleVocuerCode = this.handleVocuerCode.bind(this);
    this.applyVoucherCode = this.applyVoucherCode.bind(this);
    this.removeVoucherCode = this.removeVoucherCode.bind(this);
  }

  componentWillReceiveProps(props) {
    this.setState({
      voucher_applied: props.voucherApplied,
      voucher_savings: props.voucherSavings,
    });
  }

  handleVocuerCode(e) {
    this.setState({
      voucher_code: e.target.value,
    });
    if (e.target.value === '') {
      this.setState({
        voucher_errors: [],
        voucher_code_error_message: '',
      });
    }
  }

  applyVoucherCode() {
    if (this.props.processingState !== true) {
      this.setState({
        loading_voucher: true,
        voucher_code_error_message: '',
        voucher_errors: [],
      });
      $.ajax({
        url: this.props.voucherUrl,
        dataType: 'json',
        method: 'POST',
        data: {
          voucher: { code: this.state.voucher_code },
        },
        success: () => {
          this.setState({ loading_voucher: false });
          this.props.getSummary();
        },
        error: (jqXHR, textStatus, errorThrown) => {
          const response = JSON.parse(jqXHR.responseText);
          let errors = [];

          if (response.errors) {
            errors = response.errors;
          }
          useErrorPush(response.message, window.dataLayer);
          this.setState({
            voucher_code_error_message: response.message,
            voucher_errors: errors,
            loading_voucher: false,
          });
        },
      });
    }
  }

  removeVoucherCode() {
    this.setState({
      voucher_code_error_message: '',
      voucher_errors: [],
      loading_voucher: true,
    });
    $.ajax({
      url: this.props.voucherUrl,
      dataType: 'json',
      method: 'DELETE',
      success: () => {
        this.props.getSummary();
        this.setState({
          voucher_code: '',
          show_voucher_input: true,
          loading_voucher: false,
        });
      },
      error: textStatus => {
        if (textStatus) {
          this.setState({
            voucher_code_error_message: textStatus,
            show_voucher_input: false,
          });
        }
      },
    });
  }

  render() {
    const loadingVoucher =
      this.state.loading_voucher === true ? (
        <div className="loading-voucher" />
      ) : (
        ''
      );
    let applyVoucherCode = '';
    const title =
      this.state.voucher_applied === true ? (
        <div>
          <h5>
            <i className="icon-ok-sign" /> Voucher Applied{' '}
            {this.props.processingState === false ? (
              <span
                className="pull-right"
                onClick={this.removeVoucherCode}
                data-testid="remove-voucher-button">
                <strong>Remove</strong>
              </span>
            ) : (
              ''
            )}
          </h5>
          <span className="savings">
            Voucher Savings:{' '}
            <strong>&pound;{this.state.voucher_savings}</strong>
          </span>
        </div>
      ) : (
        <h5>Do you have a Voucher Code?</h5>
      );
    applyVoucherCode =
      this.state.voucher_applied === false ? (
        <div
          className={`apply ${
            this.state.show_voucher_input === false ? ' hide' : ''
          }`}>
          <input
            type="text"
            aria-label="voucher-input"
            onChange={this.handleVocuerCode}
            value={this.state.voucher_code}
            disabled={this.props.voucherDisabled}
          />
          <button
            className="grey-button"
            disabled={
              this.state.voucher_code === '' || this.props.voucherDisabled
            }
            onClick={this.applyVoucherCode}>
            Apply
          </button>
        </div>
      ) : (
        ''
      );
    return (
      <div
        className={`apply-a-voucher${
          this.state.voucher_applied === true ? ' applied' : ''
        }${
          this.props.processingState === true &&
          this.state.voucher_applied === false
            ? ' hide'
            : ''
        }`}>
        {loadingVoucher}
        {title}
        {this.props.voucherDisabled && (
          <AlertBox
            variant={'info'}
            body={this.props.voucherInfoMessage}
            bodyClass="fs-12"
            className="mb-16"
          />
        )}
        <div
          className={`voucher-error ${
            this.state.voucher_code_error_message === '' ? 'hide' : ''
          }`}>
          {this.state.voucher_code_error_message.length && (
            <strong
              dangerouslySetInnerHTML={{
                __html: this.state.voucher_code_error_message,
              }}
            />
          )}

          <ul className={this.state.voucher_errors.length === 0 ? 'hide' : ''}>
            {this.state.voucher_errors.map((error, index) => (
              <li key={index} dangerouslySetInnerHTML={{ __html: error }} />
            ))}
          </ul>
        </div>
        {applyVoucherCode}
        {this.props.orderType === 'MIXED' && (
          <p className="help-info">
            <i className="icon-info-sign" />
            Vouchers will not be applied to 'Reserve and Collect' items.
          </p>
        )}
      </div>
    );
  }
}

export default VoucherRedemption;
